"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FaDownload } from "react-icons/fa6";
import { FiImage } from "react-icons/fi";
import { ChatImageAttachments } from "@/components/chat/attachments";
import { useChatConfigContextOptional } from "@/components/chat/contexts/chat-config-context";
import { useChatData } from "@/components/chat/hooks";
import Button from "@/components/ui/button";
import Tooltip from "@/components/ui/tooltip";
import { useUser } from "@/contexts/user-provider";
import { useSaveToGallery } from "@/hooks/use-save-to-gallery";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
import { useFileDownload } from "./shared";
import { useRefreshSignedUrlMutation } from "@/query/comms/chat";
interface MessageImagesProps {
  images: string[];
}

/** Staff wrapper: supplies permissions, downloads and gallery saves. */
export function MessageImages(t0) {
  const $ = _c(18);
  const {
    images
  } = t0;
  const {
    download
  } = useFileDownload();
  const {
    mutateAsync: refreshSignedUrl
  } = useRefreshSignedUrlMutation();
  const {
    currentUser
  } = useUser();
  let t1;
  if ($[0] !== currentUser) {
    t1 = hasPermission(currentUser, PERMISSIONS.DOWNLOADS_EXPORT);
    $[0] = currentUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const canDownload = t1;
  const chatConfig = useChatConfigContextOptional();
  const chatId = chatConfig?.chatId;
  const t2 = chatId ?? "";
  let t3;
  if ($[2] !== t2) {
    t3 = {
      chatId: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    chat
  } = useChatData(t3);
  const patientId = chatId ? chat?.primaryPatientId : undefined;
  const {
    saveToGallery,
    isSaving
  } = useSaveToGallery(patientId);
  let t4;
  if ($[4] !== refreshSignedUrl) {
    t4 = signedUrl => refreshSignedUrl({
      signedUrl
    });
    $[4] = refreshSignedUrl;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] !== canDownload || $[7] !== download || $[8] !== isSaving || $[9] !== patientId || $[10] !== saveToGallery) {
    t5 = imageUrl => <>{patientId && <Tooltip content="Save to patient gallery"><div><Button variant="ghost" onClick={e => {
            e.stopPropagation();
            saveToGallery(imageUrl);
          }} className="bg-black bg-opacity-50 p-2 text-white hover:bg-primary hover:text-white" disabled={isSaving(imageUrl)}><FiImage size={14} /></Button></div></Tooltip>}{canDownload && <Button variant="ghost" onClick={e_0 => {
        e_0.stopPropagation();
        download(imageUrl);
      }} className="bg-black bg-opacity-50 p-2 text-white hover:bg-primary hover:text-white"><FaDownload size={14} /></Button>}</>;
    t6 = imageUrl_0 => <>{patientId && <Button variant="ghost" onClick={() => saveToGallery(imageUrl_0)} icon={<FiImage size={20} />} disabled={isSaving(imageUrl_0)}>Save to Gallery</Button>}{canDownload && <Button variant="ghost" onClick={() => download(imageUrl_0)} icon={<FaDownload size={20} />}>Download Image</Button>}</>;
    $[6] = canDownload;
    $[7] = download;
    $[8] = isSaving;
    $[9] = patientId;
    $[10] = saveToGallery;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  if ($[13] !== images || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <ChatImageAttachments images={images} onRefreshUrl={t4} renderTileActions={t5} renderViewerActions={t6} />;
    $[13] = images;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}